import Nullstack from 'nullstack';
export default function IconHomeEdit({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-home-edit",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2c.645 0 1.218 .305 1.584 .78"
  }), "   ", Nullstack.element("path", {
    d: "M20.004 11.004l-8.004 -8.004l-9 9h2v7a2 2 0 0 0 2 2h4"
  }), "   ", Nullstack.element("path", {
    d: "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
  }), " ");
}